import * as SalesStore from '../SalesStore';
import { ProductForSaleDTO, FlowAction, Res } from 'core/api';
import SaleScreen from './SaleScreen';
import { CashdrawerFacade, CatalogueFacade, RestaurantFacade } from 'pos/facades';
import { Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Message, Modal } from 'core/ui-next/modal';
import checkPendingCardTransactions from 'pos/modules/main/sale/checkPendingCardTransactions';


export default async function initSale(): Promise<Result<FlowAction>> {

	const pendingResult = await checkPendingCardTransactions();
	if (!pendingResult.ok)
		return Result.error();

	const location = SalesStore.getTicket().Location;
	const [groups, result, businessDay] = await Promise.all([CatalogueFacade.getProductGroups(location.SaleCenterId), RestaurantFacade.getSaleCenterDefaultProductGroup(location.SaleCenterId), CashdrawerFacade.getCurrentBusinessDay()]);

	if (businessDay === null) {
		await Message.show(Res.Msg.MSG_CURRENT_BUSINESS_DAY_IS_CLOSED());
		return Result.ok(FlowAction.ChangeUser);
	}

	const selectedGroup = result.HasDefaultProductGroup ? result.DefaultProductGroup : null;
	const products: ProductForSaleDTO[] = selectedGroup
		? await CatalogueFacade.getSaleableAsMainByProductGroup(selectedGroup.Type, selectedGroup.Id, SalesStore.getTicket().Id)
		: [];

	const initialSelection = selectedGroup ? { selectedGroup, products } : undefined;

	const customActionButtons = await RestaurantFacade.getCustomActionButtons();
	const profile = await RestaurantFacade.getDisplayProfile();

	await SalesStore.applyDefaultProductPreparationOrder();

	const closeResult = await Modal.show(SaleScreen, { groups, initialSelection, customActionButtons, profile, businessDay });
	return closeResult.ok ? closeResult : Result.ok(FlowAction.ChangeLocation);
}

declare global {
	interface CommandType {
		initSale: () => Promise<Result<FlowAction>>
	}
}

Command.register('initSale', 'NO_PRECONDITION', initSale);

